import {useState} from 'react'
import {FilterField} from './types'

export const useFilterState = (fields: FilterField[]) => {
  const initialState = fields.reduce((acc, field) => {
    acc[field.name] = ''
    return acc
  }, {} as Record<string, string>)

  const [filters, setFilters] = useState<Record<string, string>>(initialState)
  const [showDropdown, setShowDropdown] = useState(false)

  const handleChange = (name: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const resetFilters = () => setFilters(initialState)

  return {
    filters,
    showDropdown,
    setShowDropdown,
    handleChange,
    resetFilters,
  }
}
